

import path from 'path';

import PrettyError from 'pretty-error';
import http from 'http';
import express from 'express';
import reactRender from "./reactRender"

var router = express.Router();

router.get('/swig', function(req, res, next) {
	res.send("oop");
});

router.get('/bbb/?*', function(req, res, next) {
	const rootReucer = require("../containers/App/rootReducer");
	const route = require("../containers/App/route");

});
router.get('/takepassword/?*', function(req, res, next) {
	const rootReucer = require("../containers/TakePassword/rootReducer");
	const route = require("../containers/TakePassword/route");
	reactRender(req,res,"take-password",route,rootReucer)
});
router.get('*', function(req, res, next) {
	const rootReucer = require("../containers/TakePassword/rootReducer");
	const route = require("../containers/TakePassword/route");
	reactRender(req,res,"take-password",route,rootReucer)
});
module.exports = router;
